import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import FalseIcon from '@mui/icons-material/Clear';
//import TrueIcon from 'material-ui/svg-icons/action/done';
import TrueIcon from '@mui/icons-material/Done';

export const ReversedBooleanField = ({ source, record = {}, elStyle }) => {
    if (get(record, source) === true) {
        return <FalseIcon style={elStyle} />;
    }

    if (get(record, source) === false) {
        return <TrueIcon style={elStyle} />;
    }

    return <span style={elStyle} />;
};

ReversedBooleanField.propTypes = {
    addLabel: PropTypes.bool,
    elStyle: PropTypes.object,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

ReversedBooleanField.defaultProps = {
    addLabel: true,
    elStyle: {
        display: 'block',
        margin: 'auto',
    },
};

export default ReversedBooleanField;
